import PraisoServices from "./PraisoServices";
import { checkSession, getToken } from "./LocalStorageService";

export const AdminSearchSuggestionAPI = async (params) => {
  const ApiUrl = `admin/search/suggestion`;
  const token = getToken();
  try {
    //Check session expiry or not
    const sessionExpiry = checkSession();
    if (sessionExpiry) {
      return sessionExpiry;
    }
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...params,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminSearchResultAPI = async (params) => {
  const ApiUrl = `admin/search`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...params,
      },
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminSearchSuggestion = async (params) => {
  const data = await AdminSearchSuggestionAPI(params);
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const adminSearchResult = async (params) => {
  const data = await AdminSearchResultAPI(params);
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};
